//
//
//
//
//
//
//
//
//
//
//

import {detectOS} from './utils'

export default {
  name: 'HView',
  props: {
    fullScreen: {
      // 是否为全屏应用，全屏子应用此项需设为true
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isIos: false,
    }
  },
  created () {
    this.fullScreen && detectOS() === 'ios' && (this.isIos = true)
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/HView/index.vue